import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MpesaConfigFetched {
  _id?: string;
  bp_location_id?: string;
  bp_mpesa_configuration_c2b_shortcode_information?: string;
  bp_mpesa_configuration_c2b_shortcode_type_information?: string;
  bp_mpesa_configuration_b2c_shortcode_information?: string;
  bp_mpesa_configuration_b2b_shortcode_information?: string;
  bp_mpesa_configuration_information_created_at?: string;
  bp_mpesa_configuration_information_updated_at?: string;
}

export interface MpesaConfigSliceObject {
  fetched: MpesaConfigFetched | null;
}

const initialState: MpesaConfigSliceObject = {
  fetched: null,
};

const mpesaConfigSlice = createSlice({
  name: 'mpesaConfig',
  initialState,
  reducers: {
    setFetchedMpesaConfig: (
      state,
      action: PayloadAction<MpesaConfigFetched | null>,
    ) => {
      state.fetched = action.payload ?? null;
    },
    clearFetchedMpesaConfig: state => {
      state.fetched = null;
    },
  },
});

export const { setFetchedMpesaConfig, clearFetchedMpesaConfig } =
  mpesaConfigSlice.actions;

export default mpesaConfigSlice.reducer;

// Selectors
import type { RootState } from './types';

export const selectFetchedMpesaConfig = (state: RootState) =>
  state.mpesaConfig.fetched;
